
import React, { useState } from "react";
import { Section } from "./SeoUI";

const INITIAL_PROMPT = "Find me a good Formal dress for a dinner party";

const ASSISTANT_RESPONSE =
  "I found 2 perfect matches curated for your profile. Linen provides the breathability you need, while these specific wrap and empire silhouettes naturally highlight your waist to balance your proportions.";

const products = [
  {
    id: 1,
    brand: "Reformation",
    name: "Pleated Silk Wrap Blouse (#33445)",
    price: "$250",
    match: "95% match on you",
  },
  {
    id: 2,
    brand: "Reformation",
    name: "Pleated Silk Wrap Blouse (#33445)",
    price: "$250",
    match: "95% match on you",
  },
];

const StylistSection = () => {
  const [chatMode, setChatMode] = useState("Style");
  const [chatInput, setChatInput] = useState(INITIAL_PROMPT);
  const [messages, setMessages] = useState([
    { role: "user", text: INITIAL_PROMPT },
  ]);
  const [activeTab, setActiveTab] = useState("History");

  const handleSend = (e) => {
    e.preventDefault();
    const prompt = chatInput.trim();
    if (!prompt) return;

    setMessages((prev) => [
      ...prev,
      { role: "user", text: prompt },
    ]);
    setChatInput("");
  };

  const handleNewChat = () => {
    setMessages([]);
    setChatInput("");
    setActiveTab("New Chat");
  };

  const handleHistory = () => {
    setActiveTab("History");
  };

  const handleClear = () => {
    setMessages([]);
    setChatInput("");
  };

  return (
    <Section
      id="stylist"
      className="bg-[#111111] py-16 text-white md:py-20 lg:py-[78px]"
    >
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:gap-[70px] xl:gap-[100px]">

        {/* LEFT CONTENT */}
        <div className="min-w-0">
          {/* Eyebrow */}
          <div className="mb-[17px] flex items-center gap-[7px]">
            <span className="h-[6px] w-[6px] shrink-0 rounded-full bg-[#F26633]" />
            <span className="font-jetBrainsMono text-[10px] md:text-[11px] uppercase tracking-[8%] text-[#F26633]">
              MODULE: GPT_ASSISTANT
            </span>
          </div>

          {/* Heading */}
          <h2 className="max-w-[440px] font-inter text-[32px] font-medium leading-[1.1] tracking-[-0.035em] text-white md:text-[36px]">
            A stylist that speaks
            <br className="hidden sm:block" />
            {" "}your language.
          </h2>


          {/* Description */}
          <p className="mt-[19px] max-w-[460px] font-inter text-[13px] md:text-[15px] leading-[1.55] text-[#FFFFFFB2]">
            Ask in plain English — "a midi for a beach wedding
            under $300, that flatters an hourglass" — and Eveness
            comes back with curated picks, the reasoning, and
            explicit notes on what to avoid for your frame.
          </p>

          {/* Feature rows */}
          <div className="mt-[24px] flex flex-col gap-[7px]">
            {[
              [
                "EXAMPLES",
                "Does this dress suit me for a wedding?",
              ],
              [
                "CAPABILITIES",
                "Understands your unique style",
              ],
              [
                "LIMITATIONS",
                "Cannot replace personal taste",
              ],
            ].map(([label, value]) => (
              <div
                key={label}
                className="flex min-h-[36px] items-center gap-3 rounded-[4px] border border-[#FFFFFF1A] bg-[#FFFFFF08] px-[12px] py-[10px] font-jetBrainsMono"
              >
                <span className="w-[99px] shrink-0 font-jetBrainsMono text-[10px] md:text-[11px] uppercase tracking-[0.04em] text-[#F26633]">
                  {label}
                </span>

                <span className="min-w-0 font-inter text-[11px] md:text-[13px] leading-[100%] text-[#FFFFFFD9]">
                  {value}
                </span>
              </div>
            ))}
          </div>

          {/* Left search bar */}
          <form
            onSubmit={handleSend}
            className="mt-[17px] flex min-h-[47px] items-center gap-[8px] rounded-full bg-[#1A1A1A] p-[6px]"
          >
            <div className="flex shrink-0 items-center rounded-full bg-[#292929] p-1 gap-1 h-[35px]">
              {["Find", "Style"].map((mode) => (
                <button
                  key={mode}
                  type="button"
                  onClick={() => setChatMode(mode)}
                  className={`h-[27px] rounded-full px-3 py-[6px] font-jetBrainsMono text-[10px] transition-colors ${
                    chatMode === mode
                      ? "bg-white text-[#292929]"
                      : "text-[#AFAFAF] hover:text-white"
                  }`}
                >
                  {mode}
                </button>
              ))}
            </div>

            <input
              aria-label="Stylist prompt"
              type="text"
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              placeholder="Find me a good formal dress for a dinner party"
              className="min-w-0 flex-1 bg-transparent px-[5px] font-inter text-[11px] md:text-[13px] text-[#D9D9D9] outline-none placeholder:text-[#777777]"
            />

            <span className="hidden shrink-0 rounded bg-[#343434] px-2 py-1 font-jetBrainsMono text-[10px] md:text-[11px] text-[#FFFFFF99] sm:block">
              ⌘K
            </span>

            <button
              type="submit"
              className="shrink-0 rounded-full bg-[#F26633] px-[14px] py-[8px] font-inter text-[10px] md:text-[12px] font-medium text-white transition hover:bg-[#E45A29]"
            >
              Send
            </button>
          </form>
        </div>

        {/* RIGHT CHAT PREVIEW */}
        <div className="flex min-h-[591px] min-w-0 flex-col overflow-hidden rounded-[3px] border border-[#E5E5E5] bg-white text-[#252525] shadow-[0_10px_30px_rgba(0,0,0,0.12)] lg:h-[440px]">

          {/* Chat body */}
          <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-[17px] pt-[3px] pb-[12px] sm:px-[23px]">

            {/* Header tabs */}
            <div className="w-fit rounded-[3px] bg-[#3B3A3A] p-[3px]">
              <div className="flex items-center gap-[2px]">
                {["History", "New Chat", "Delete Chat"].map(
                  (tab) => (
                    <button
                      key={tab}
                      type="button"
                      onClick={() => {
                        if (tab === "New Chat") {
                          handleNewChat();
                        } else if (tab === "Delete Chat") {
                          handleClear();
                          setActiveTab(tab);
                        } else {
                          handleHistory();
                        }
                      }}
                      className={`rounded-[3px] px-[8px] py-[4px] text-[#818181] font-montserrat text-[9px] transition ${
                        activeTab === tab
                          ? "bg-white font-medium"
                          : "text-[#B0B0B0] hover:text-white"
                      }`}
                    >
                      {tab}
                    </button>
                  ),
                )}
              </div>
            </div>

            {/* User message */}
            <div className="mt-[15px] flex flex-col gap-[8px] rounded-[3px]">          
              {messages.map((message, index) => (
                <div
                  key={index}
                  className="ml-auto max-w-[214px] rounded-[5px] bg-[#F4F4F4] px-[11px] py-[9px] font-helvena text-[10px] text-[#0D0D0D]"
                >
                  {message.text}
                </div>
              ))}
            </div>

            {/* Assistant response */}
            <div className="mt-[13px] flex items-start gap-[10px]">
              <div className="mt-[2px] h-[17px] w-[17px] shrink-0 rounded-[3px] bg-[#252525]" />

              <div className="min-w-0 flex-1">
                <p className="max-w-[420px] font-helvena text-[10px] leading-[1.55] text-[#252525]">
                  {ASSISTANT_RESPONSE}
                </p>

                {/* Product recommendations */}
                <div className="mt-[11px] flex flex-col gap-[8px]">
                  {products.map((product) => (
                    <div
                      key={product.id}
                      className="flex w-full max-w-[280px] gap-[9px] rounded-[3px] border border-[#DFDFDF] bg-white p-[6px]"
                    >
                      {/* Image placeholder */}
                      <div className="h-[55px] w-[55px] shrink-0 rounded-[3px] bg-[#D5D5D5]" />

                      <div className="min-w-0 flex-1">
                        <div className="flex items-center justify-between gap-2">
                          <span className="truncate font-helvena text-[10px] font-medium text-black">
                            {product.brand}
                          </span>

                          <span className="shrink-0 font-helvena text-[9px] text-black">
                            {product.price}
                          </span>
                        </div>

                        <p className="mt-[3px] truncate font-helvena text-[8px] text-[#1A1A26]">
                          {product.name}
                        </p>

                        <div className="mt-[5px] flex items-center justify-between gap-2">
                          <span className="rounded-[2px] bg-[#DBE7FA] px-[5px] py-[3px] font-spaceMono text-[8px] text-[#3D648B]">
                            {product.match}
                          </span>
                          <span className="shrink-0 font-helvena text-[8px] text-[#595973]">
                            View Product
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Why this works */}
                <div className="mt-[10px] max-w-[315px] rounded-[4px] bg-[#EFF5F0] px-[11px] py-[10px]">        
                  <div className="flex items-center gap-[8px] text-[#3D8B5E]">
                    <span className="text-[10px] font-spaceMono">✓</span>
                    <span className="font-helvena text-[10px] font-medium">
                      Why this works
                    </span>
                  </div>

                  <p className="mt-[4px] font-helvena text-[9px] leading-[1.55] text-[#335940]">
                    This style complements your body proportions
                    and matches your preference for structured
                    silhouettes with waist definition.
                  </p>
                </div>

                {/* What to avoid */}
                <div className="mt-[8px] max-w-[315px] rounded-[4px] bg-[#FAF0F0] px-[11px] py-[10px]">
                  <div className="flex items-center gap-[8px] text-[#B85C5C]">
                    <span className="text-[10px] font-spaceMono">✗</span>
                    <span className="font-helvena text-[10px] font-medium">
                      What to avoid
                    </span>
                  </div>

                  <p className="mt-[4px] font-helvena text-[9px] leading-[1.55] text-[#8C4747]">
                    Oversized fits may overwhelm your frame.
                    Look for tailored or slim cuts instead.
                  </p>
                </div>

                {/* Follow-up response */}
                <p className="mt-[11px] max-w-[375px] font-helvena text-[10px] leading-[1.55] text-[#0D0D0D]">
                  {ASSISTANT_RESPONSE}
                </p>

                {/* Copy / Refresh icons */}
                <div className="mt-[5px] flex items-center gap-[10px]">
                  <button
                    type="button"
                    aria-label="Copy assistant response"
                    onClick={() =>
                      navigator.clipboard?.writeText(
                        ASSISTANT_RESPONSE,
                      )
                    }
                    className="text-[#444444] hover:text-black"
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.7"
                    >
                      <rect
                        x="8"
                        y="8"
                        width="12"
                        height="12"
                        rx="1"
                      />
                      <path d="M16 8V4H4v12h4" />
                    </svg>
                  </button>

                  <button
                    type="button"
                    aria-label="Reset example response"
                    onClick={() => {
                      setMessages([
                        {
                          role: "user",
                          text: INITIAL_PROMPT,
                        },
                      ]);
                    }}
                    className="text-[#444444] hover:text-black"
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.7"
                    >
                      <path d="M20 7v5h-5" />
                      <path d="M4 17v-5h5" />
                      <path d="M5.5 9A7 7 0 0118 7l2 5M4 12l2 5a7 7 0 0012.5-2" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom toolbar */}
          <div className="mx-[15px] mb-[5px] flex min-h-[34px] items-center gap-[6px] rounded-[4px] bg-[#252525] px-[7px] py-[5px] sm:mx-[17px]">
            <div className="flex shrink-0 items-center gap-[3px]">
              {["Find", "Style"].map((mode) => (
                <button
                  key={mode}
                  type="button"
                  onClick={() => setChatMode(mode)}
                  className={`rounded-[3px] px-[9px] py-1 text-[9px] font-medium font-helvena ${
                    chatMode === mode
                      ? "bg-white text-black"
                      : "bg-[#3B3A3A] text-white"
                  }`}
                >
                  {mode}
                </button>
              ))}
            </div>

            <span className="px-[4px] text-[13px] text-[#B7B7B7] font-medium font-helvena">
              ✦
            </span>

            <form
              onSubmit={handleSend}
              className="flex min-w-0 flex-1 items-center gap-[5px]"
            >
              <input
                aria-label="Chat message"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                placeholder="Search for a product, ask styling advice..."
                className="min-w-0 flex-1 bg-transparent font-medium text-center font-helvena text-[9px] text-white outline-none placeholder:text-[#989898]"
              />

              <button
                type="button"
                onClick={() => setChatInput("")}
                aria-label="Clear input"
                className="px-[4px] text-[10px] text-[#777777] font-spaceMono"
              >
                ⌘K
              </button>

              <button
                type="submit"
                className="rounded-[3px] bg-gradient-to-br from-[#E7B0A1] via-[#E59C93] to-[#A84447] px-[12px] py-[7px] font-inter text-[9px] text-white"
              >
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default StylistSection;
